import 'regenerator-runtime'
import './index.css'
import {EventBus, EventTypes} from './consts/const-event-types'

//Import lazysizes as early as possible.
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';


//Set lazysizes configuration.
lazySizes.cfg.lazyClass = 'lazyload';
lazySizes.cfg.loadedClass = 'loaded';
lazySizes.cfg.customMedia = {
  '--small': '(max-width: 640px)',
  '--medium': '(max-width: 1024px)',
  '--large': '(min-width:1440px)',
  '--xlarge': '(min-width:1920px)'
}

const components = [
  {load: () => import(/* webpackChunkName: "component-header" */ './components/header/header'), selectorName: 'header'},
  {load: () => import(/* webpackChunkName: "component-carousel" */ './components/carousel/carousel'), selectorName: 'carousel'},
  {load: () => import(/* webpackChunkName: "component-navigation" */ './components/navigation/navigation'), selectorName: 'navigation'},
  {load: () => import(/* webpackChunkName: "component-header-carousel" */ './components/header-carousel/header-carousel'), selectorName: 'header-carousel'},
  {load: () => import(/* webpackChunkName: "component-slider" */ './components/Modules/Slider/slider'), selectorName: 'slider'},
  {load: () => import(/* webpackChunkName: "component-faq" */ './components/Modules/Faq/faq'), selectorName: 'faqs'},
  {load: () => import(/* webpackChunkName: "component-insights" */ './components/Modules/insights/insights'), selectorName: 'insights'},
  {load: () => import(/* webpackChunkName: "component-office-carousel" */ './components/offices-carousel/office-carousel'), selectorName: 'office-carousel'},
  {load: () => import(/* webpackChunkName: "component-vimeo-module" */ './components/vimeo-module/vimeo-module'), selectorName:'vimeo-module'},
  {load: () => import(/* webpackChunkName: "component-promo-vimeo-module" */ './components/promo-video-module/promo-vimeo-module'), selectorName:'promo-vimeo-module'},
  {load: () => import(/* webpackChunkName: "component-testimonial" */ './components/testimonial-module/testimonial-module'), selectorName: 'testimonial-module'},
  {load: () => import(/* webpackChunkName: "component-inline-icons" */ './components/inline-icons-module/inline-icons.module'), selectorName: 'inline-icons-module'},
  {load: () => import(/* webpackChunkName: "component-our-values" */ './components/our-values-module/our-values-module'), selectorName: 'our-values-module'},
  {load: () => import(/* webpackChunkName: "component-office-list" */ './components/office-list-module/office-list.module'), selectorName: 'office-list-module'},
  {load: () => import(/* webpackChunkName: "component-contact-form" */ './components/contact-form-module/contact-form-module'), selectorName: 'contact-form-module'},
  {load: () => import(/* webpackChunkName: "component-scroll-to-form" */ './components/Modules/Forms/scroll-to-form'), selectorName: 'scroll-to-form'},
  {load: () => import(/* webpackChunkName: "component-umbraco-forms" */ './components/umbraco-forms/umbraco-forms'), selectorName: 'umbraco-forms'},
  {load: () => import(/* webpackChunkName: "component-thank-you" */ './components/umbraco-forms/thank-you'), selectorName: 'thank-you'},
]

/*
* ComponentInstantiator traverses the DOM-tree and looks for [data-component='] attributes.
*/
class ComponentInstantiator {
  constructor() {
    this.componentsInstantiated = {}
    this.ready = this.createComponents().then(() => {
      this.dispatchReady()
      return this
    })
    return this
  }

  async createComponents() {
    await Promise.all(components.map(async component => {
      const nodeItems = [...document.querySelectorAll("[data-component='" + component.selectorName + "']")]
      if (!nodeItems.length) return

      const module = await component.load()
      const ComponentClass = module.default
      this.componentsInstantiated[component.selectorName] = nodeItems.map(nodeItem => new ComponentClass(nodeItem))
    }))
  }

  dispatchReady() {
    const event = new CustomEvent(EventTypes.ALL_COMPONENTS_READY)
    EventBus.dispatchEvent(event)
  }

  getComponents(selectorName) {
    return selectorName ? this.componentsInstantiated[selectorName] : this.componentsInstantiated
  }
}

/* Make your App accessible via window.App */
window.App = new ComponentInstantiator()

/* Access components list */
// console.log('components on this page', window.App.getComponents())
